/**
 * True for a click the browser itself turns into "open in a new tab / window"
 * when it lands on a real link: any button but the primary one (middle click
 * arrives as `auxclick`, but a synthetic or forwarded one may carry button 1),
 * or a primary click with Ctrl/Cmd, Shift or Alt held. Mirrors vue-router's
 * RouterLink guard, so a nav entry that renders `<a href>` leaves exactly these
 * clicks to the browser and routes every other one in place.
 */
export function opensInNewTab(event: MouseEvent): boolean {
  return event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey;
}
